import {makeAutoObservable} from 'mobx';
import {Option} from "../Components";

export type SiteDTO = FilterGroupDTO & {
    regionId: string
}
export type DeviceDTO = SiteDTO & {
    siteId: string
}
export type DeviceResponseDTO = FilterGroupDTO & {
    siteId: string
}
export type FilterGroupDTO = {
    id: string
    name: string
}

export class FilterDTO {
    customers: FilterGroupDTO[] = [];
    regions: FilterGroupDTO[] = [];
    sites: SiteDTO[] = [];
    plants: DeviceDTO[] = [];

    constructor() {
        makeAutoObservable(this);
    }
}

/*TODO: Remove Old Models*/

export type ResponseDTO<T> = {
    result: T[]
    skip: number
    take: number
    count: number
}
export type KeyString = { [key: string]: string }

export type AlarmGroups = {
    deviceId: string
    count: number
    name: number
    id: string
    ratio: number
}
export type AlarmsDTO = {
    deviceId: string
    name: string
    text: string
    count: number
    ratio: number
}
export type MetricsDTO = {
    deviceId: string
    groupId: string
    groupName: string
    componentId: string
    componentName: string
    name: string
    category: string
    ratio: number
    ratioLowerLimit: number
}
export type SiteInfoDTO = {
    id: string,
    name: string,
    regionId: string,
    isPublic: boolean,
}
export type ConditionDTO = {
    alarms: AlarmsDTO[],
    alarmGroups: AlarmGroups[],
    metrics: MetricsDTO[],
}

export enum MaintenanceStatus {
    Pending = "Pending",
    Completed = "Completed",
    Cancelled = "Cancelled"
}

export type SortingItem = {
    key: string,
    label: string,
    isBool?: boolean,
    options?: Option[],
};

export enum SupportTicketStatusDTO {
    InProgress = 'InProgress',
    MarkedForClosing = 'MarkedForClosing',
    OnHold = 'OnHold',
    WaitingForDetails = 'WaitingForDetails',
    Researching = 'Researching',
    CreateQuotes = 'CreateQuotes',
    CreateOrders = 'CreateOrders',
    WaitingOnCustomerOrder = 'WaitingOnCustomerOrder',
    NotStarted = 'NotStarted',
    ProblemSolved = 'ProblemSolved',
    InformationProvided = 'InformationProvided',
    LeadCreated = 'LeadCreated',
    Cancelled = 'Cancelled',
    Merged = 'Merged',
    UnsolvedClosed = 'UnsolvedClosed',
    TicketSolved = 'TicketSolved'
}

export const ClassificationDTO: KeyString = {
    ControlSystems: 'Control Systems',
    Mechanical: 'Mechanical',
    ProcessTechnology: 'Process Technology',
    General: 'General',
};

export const SupportTicketStatusLabelDTO: KeyString = {
    [SupportTicketStatusDTO.InProgress as string]: 'In Progress',
    [SupportTicketStatusDTO.MarkedForClosing as string]: 'Marked For Closing',
    [SupportTicketStatusDTO.OnHold as string]: 'On Hold',
    [SupportTicketStatusDTO.WaitingForDetails as string]: 'Waiting For Details',
    [SupportTicketStatusDTO.Researching as string]: 'Researching',
    [SupportTicketStatusDTO.CreateQuotes as string]: 'Create Quotes',
    [SupportTicketStatusDTO.CreateOrders as string]: 'Create Orders',
    [SupportTicketStatusDTO.WaitingOnCustomerOrder as string]: 'Waiting On Customer Order',
    [SupportTicketStatusDTO.NotStarted as string]: 'Not Started',
    [SupportTicketStatusDTO.ProblemSolved as string]: 'Problem Solved',
    [SupportTicketStatusDTO.InformationProvided as string]: 'Information Provided',
    [SupportTicketStatusDTO.LeadCreated as string]: 'Lead Created',
    [SupportTicketStatusDTO.Cancelled as string]: 'Cancelled',
    [SupportTicketStatusDTO.Merged as string]: 'Merged',
    [SupportTicketStatusDTO.UnsolvedClosed as string]: 'Unsolved Closed',
    [SupportTicketStatusDTO.TicketSolved as string]: 'Ticket Solved',
};

export type MaintenanceDTO = {
    name: string
    taskId: string
    overdue: number
    due: number
    value: number,
    cycle: number,
    initialValue: number,
    timestamp: string,
    timeDelta: string,
    componentId: string,
    status: MaintenanceStatus,
    completed: Date,
    time: Date,
    description: string,
    comment: string,
    user: string,
    type: string,
    measurement: string,
    log: string,
    valueDelta: number,
    isAlmostDue: boolean,
    isRecurring?: boolean,
    isScheduled?: boolean,
    initialTime?: Date,
    timeD?: number,
    timeH?: number,
    deviceId: string,
    userLog: {
        id: string,
        message: string,
        displayName: string,
        email: string
    },
    operatingHoursPerWeek?: number,
    operatingHours?: number,
    isManualDuration?: boolean,
    ticketId: string
}

export type NewMaintenanceDTO = {
    description: string,
    deviceId: string,
    organizationId: string,
    isRecurring: boolean,
    status?: MaintenanceStatus,
    userId?: string,
    ticketId?: string,
    value?: number,
    log?: string,
    logMessage?: string,
    measurement?: string,
    valueDelta?: number,
    initialTime?: string,
    timeDelta?: string,
}
export type MeasurementDTO = {
    id: string,
    name: string,
    unit: string,
    componentId: string,
    category: string,
    ratioLimit: number,
}
export type ConditionChartDataDTO = {
    current: ConditionDTO,
    historical: ConditionDTO,
    inspection: MaintenanceDTO[],
    revision: MaintenanceDTO[]
    events: MaintenanceDTO[]
}
export type EfficiencyKpiDTO = {
    deviceId: string,
    siteId: string,
    performance: number,
    availability: number,
    overall: number,
    overallLowerLimit: number,
    quality: number,
}
export type EfficiencyEnergyDTO = {
    deviceId: string,
    name: string,
    siteId: string,
    unit: string,
    value: number,
}
export type EfficiencyDTO = {
    effectiveness: EfficiencyKpiDTO[],
    specificEnergyConsumption: EfficiencyEnergyDTO[]
    totalEnergyConsumption: EfficiencyEnergyDTO[]
    totalRawMaterialConsumption: EfficiencyEnergyDTO[]
    throughput: EfficiencyEnergyDTO[]
}
export type EfficiencyChartDataDTO = {
    current: EfficiencyDTO,
    historical: EfficiencyDTO,
}
export type SiteEfficiencyDTO = {
    siteId: string
    overall: number,
    overallLowerLimit: number,
}

export enum TicketType {
    Incident = "Incident",
    Request = "Request"
}

export enum TaskType {
    scheduled = "Scheduled Based",
    data = "Data Based"
}

export enum TicketPriority {
    Low = "Low",
    Normal = "Normal",
    High = "High",
}

export enum TicketClassification{
    ControlSystems = "Control Systems",
    Mechanical = "Mechanical",
    ProcessTechnology = "Process Technology",
    General = "General",
}

export type ComponentTDO = {
    id: string,
    name: string
}
export type OptionTDO = {
    value: string,
    label: string
}

export enum ServiceChangeKey {
    isResolved = 'isResolved',
    isNotResolved = 'isNotResolved',
}

export type AttachmentTDO = {
    id: string,
    name: string
    createdOn: string
    contentType: string
}

export type SupportTicketDTO = {
    id: string,
    status?: string,
    title: string,
    type: TicketType,
    priority: TicketPriority,
    classification: TicketClassification;
    deviceId: string,
    componentId?: string,
    componentIds: string[],
    category?: string,
    userId: string,
    siteId: string,
    number: string,
    description: string,
    slaStatus: string,
    currentSlaEffort: string,
    taskId?: string,
    createdOn: Date,
    modifiedOn: Date,
    resolvedOn?: Date,
    summaryAttachmentId?: string,
    isResolved: boolean,
    user: {
        id: string,
        displayName: string,
    },
    isInCompletedTask?: boolean
}

export type CommentTDO = {
    id: string,
    content: string,
    createdOn: Date,
    modifiedOn: Date,
    isCustomerBound: boolean,
    attachments: AttachmentTDO[],
    user: {
        id: string,
        displayName?: string,
    }
}

export enum UserRoleDTO {
    Admin = "Admin",
    User = "User",
    None = "None",
}

export type UserDTO = {
    id: string,
    displayName: string,
    userId: string,
    role: UserRoleDTO,
    organizationId: string,
    regionId: string,
    siteId: string,
    areaId: string,
    deviceId: string
}

